import React from 'react';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { NavigationItem } from 'ui-toolkit';
import { ClientUrlFactory } from 'ui-toolkit/rest/ClientUrlFactory';

export const PolicyEditButton = () => {
  const { data: order } = useSelectCurrentOrder();
  const feesUrl =
    order.fees_version === 'v2'
      ? ClientUrlFactory().urlFor.feesTab(order.transaction.id!)
      : ClientUrlFactory().urlFor.cdItemsV3(order.transaction.id!);

  return <NavigationItem intent={'secondary'} appearance={'default'} text={'Edit'} to={feesUrl} />;
};
